<template>
  <div class="bg-white border-solid border-0 border-l border-gray-a10 h-full flex flex-col px-4 pt-4">
    <BaseToggleGroup class="mt-4" :tabs="tabs" v-model="activeTab" />

    <BaseCallout
      v-if="action && action.isFallback"
      class="mt-6"
      text='FALLBACK: Nothing found in custom knowledge base. Knowledge type "General" was used to handle the request.'
    />

    <!-- Interpolated, not a BaseCallout: the message comes from the model/API and BaseCallout renders v-html. -->
    <div v-if="errorMessage" class="mt-6 p-2 border-0 border-l-8 border-solid border-primary text-primary bg-primary bg-opacity-10">
      The GPT action failed: {{ errorMessage }}
    </div>

    <div class="mt-6 overflow-y-auto" v-bar>
      <!-- General: ChatGPT config without prompts -->
      <ChatGPTEditor
        v-if="activeTab === 'general'"
        :cachedAction="action"
        :hideSections="true"
        :isDisabled="true"
        class="pr-6"
      />

      <!-- Prompt: system, user, search metadata, message history -->
      <ChatGPTActionDetailPrompt
        v-if="activeTab === 'prompt'"
        :action="action"
        :formData="formData"
        class="pr-6"
      />

      <!-- API: options, message history,response body, intent labels, citations -->
      <ChatGPTActionDetailApi
        v-if="activeTab === 'api'"
        :formData="formData"
      />
    </div>
  </div>
</template>

<script>
import ChatGPTEditor from '@/components/editor/ChatGPTEditor.vue'
import ChatGPTActionDetailPrompt from './ChatGPTActionDetailPrompt.vue'
import ChatGPTActionDetailApi from './ChatGPTActionDetailApi.vue'

export default {
  name: 'ChatGPTActionDetail',
  components: { ChatGPTEditor, ChatGPTActionDetailPrompt, ChatGPTActionDetailApi },

  props: {
    formData: {
      type: Object,
      default: null
    }
  },

  data() {
    return {
      isLoading: false,
      // The component is keyed per event, so props are stable for its lifetime.
      activeTab: this.formData?.data?.action ? 'general' : 'api'
    }
  },

  computed: {
    // PRO-517: a turn that failed before/while the strategy answered has no action — General and Prompt
    // would render an empty config, so only API (response body, message history, citations) is offered.
    tabs() {
      const apiTab = { key: 'api', label: 'API' }
      if (!this.action) return [apiTab]

      return [
        { key: 'general', label: 'General' },
        { key: 'prompt', label: 'Prompt' },
        apiTab
      ]
    },

    action() {
      return this.formData?.data?.action
    },

    // Errors are stored two ways: inside `context` (current), or as the whole event before PRO-517 —
    // events already in the database still have the old shape.
    errorMessage() {
      const data = this.formData?.data
      if (data?.context?.error) return data.context.body
      return data?.error ? data.response : null
    }
  }
}
</script>
